import PropTypes from "prop-types";
import { ButtonTypes } from "./types";
// For legacy purposes
export const ButtonTypesPropTypes = PropTypes.oneOf(Object.values(ButtonTypes));
export { ButtonTypes };
//# sourceMappingURL=ButtonPropTypes.js.map